import React from "react";
import styled from "styled-components";
import { FontSize, content } from "@glossy";
import { Platform } from "@linkfluence/models/platform";
import { Post, PostLens, PostLensFactory } from "@radarly/models/posts";

interface IProps {
  post: Post;
  className?: string;
}

const ScreenName = styled.span`
  color: ${(props) => content(props, "secondary")};
  font-size: ${FontSize.Medium};
`;

const getScreenName = (post: Post) => {
  if (
    PostLens.isPlatform(Platform.Twitter, post) ||
    PostLens.isPlatform(Platform.Vkontakte, post)
  ) {
    return PostLensFactory.create(post).getAuthorScreenName();
  }
  return null;
};

const RadarlyPostAuthorScreenName = ({ post, className }: IProps) => {
  const screenName = getScreenName(post);
  return screenName ? (
    <ScreenName className={className}>@{screenName}</ScreenName>
  ) : null;
};

export default RadarlyPostAuthorScreenName;
